module.exports = __webpack_public_path__ + "static/media/phone_pick_white.a50eabeb.png";